import { FC } from 'react';
import { ErrorHandlerAlert } from '../../molecules';
import { EditableComponent } from '@adobe/aem-react-editable-components';
import clsx from 'clsx';

interface ComponentProps {
  id?: string;
  componentErrorMessage?: string;
}

export const MerchBanner: FC<ComponentProps> = props => {
  const { id } = props;
  return (
    <ErrorHandlerAlert alertMessage={props?.componentErrorMessage}>
      <div id={id}>
        <div id="serp-merch-banner-component-container" className={clsx('m-container-fullbleed')}></div>
      </div>
    </ErrorHandlerAlert>
  );
};
export const MerchBannerConfig = {
  emptyLabel: 'MerchBanner',
  isEmpty: false,
  resourceType: `mi-aem-shop-spa/components/content/merchbanner/v1/merchbanner`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const MerchBannerEditable = (props: any) =>
  props.cqPath.includes('experiencefragment') ? (
    <MerchBanner {...props} />
  ) : (
    <EditableComponent config={MerchBannerConfig} {...props}>
      <MerchBanner {...props} />
    </EditableComponent>
  );
